export default "__VITE_ASSET__Dzxk0x3t__"